import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './BuilderField.module.scss'

const BuilderField = ({ label, htmlFor, required = false, hint, children }) => (
  <div>
    <div className={classNames('d-flex align-items-baseline justify-content-between', classes.labelRow)}>
      <label htmlFor={htmlFor} className={classes.label}>
        {label}
        {required && <span className={classes.required}> *</span>}
      </label>
      {hint && <span className={classes.hint}>{hint}</span>}
    </div>
    {children}
  </div>
)

BuilderField.propTypes = {
  label: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  hint: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default BuilderField
